const escapeRegExp = (s: string) => s.replace(/[-/\\^$+?.()|[\]{}]/g, '\\$&');

export const patternToRegExp = (pattern: string): RegExp => {
    if (pattern.endsWith('/*')) {
        const base = pattern.slice(0, -2);
        return new RegExp('^' + escapeRegExp(base) + '(/.*)?$');
    }
    const replaced = pattern.split('*').map(escapeRegExp).join('[^/]+');
    return new RegExp('^' + replaced + '$');
};

export const matchesAny = (patterns: string[], path: string) => patterns.some((p) => patternToRegExp(p).test(path));
